import { Flex, IllustratedMessage } from '@percent/lemonade'
import { useTranslation, Trans } from 'react-i18next'
import styles from './ErrorState.module.scss'
import { HELP_LINK } from '@percent/cause-dashboard/constants/support'
import { LocaleKey } from '@percent/cause-dashboard/i18n/config'

export interface ErrorStateProps {
  title?: string
  description?: LocaleKey
}

export const ErrorState = ({ title, description }: Readonly<ErrorStateProps>) => {
  const { t } = useTranslation()

  const helpLink = (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a href={HELP_LINK} target="_blank" rel="noopener noreferrer" className={styles.linkHelpCenter} />
  )

  return (
    <Flex className={styles.errorStateOuterContainer}>
      <Flex className={styles.errorStateInnerContainer}>
        <IllustratedMessage
          illustration="invalid-link"
          title={title ?? t('myDiscounts.error.title')}
          description={
            <Trans
              // @ts-expect-error - i18nKey is not typed correctly
              i18nKey={description ?? 'myDiscounts.error.genericDescription'}
              components={{ a: helpLink }}
            />
          }
        />
      </Flex>
    </Flex>
  )
}
